import React from 'react';
import dynamic from 'next/dynamic';
import { useFeatureFlagEnabled } from '@/lib/posthog/PostHogContext';
import { logger } from '@/lib/logger';

const LegacyOrders = dynamic(
  () => import('../../components/accounts/Orders/LegacyOrders'),
);
const MyOrders = dynamic(
  () => import('../../components/accounts/Orders/MyOrders'),
);

export default function Orders() {
  const isNewOrdersPageEnabled = useFeatureFlagEnabled(
    'rt-14747-my-orders-revamp',
  );

  if (isNewOrdersPageEnabled) {
    logger.info('Rendering new My Orders page', { isNewOrdersPageEnabled });

    return <MyOrders />;
  }

  logger.info('Rendering legacy Orders page', { isNewOrdersPageEnabled });

  return <LegacyOrders />;
}
